var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmall = function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 156 163"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#small_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5D7C8",
    d: "M71.44 154.473C34.803 151.268 7.618 119.374 10.774 83.3l4.161-47.557c.455-5.203 3.836-9.699 8.728-11.605L78.526 2.76a13.93 13.93 0 0 1 12.281 1.075l50.318 30.58c4.486 2.726 7.035 7.74 6.58 12.944l-4.161 47.557c-3.156 36.074-35.466 62.762-72.104 59.557"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5D7C8",
    fillRule: "evenodd",
    d: "M15.423 82.896c-2.974 33.992 22.307 64.014 56.418 66.999 34.11 2.984 64.221-22.193 67.195-56.184l4.126-47.17a9.18 9.18 0 0 0-4.353-8.622L88.503 7.015a9.28 9.28 0 0 0-8.26-.722L25.334 27.99a9.18 9.18 0 0 0-5.784 7.735zm66.962-56.011a3.454 3.454 0 0 0 3.75-3.131 3.454 3.454 0 0 0-3.149-3.734 3.454 3.454 0 0 0-3.75 3.13 3.454 3.454 0 0 0 3.15 3.735",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002003",
    fillRule: "evenodd",
    d: "M70.055 136.779c14.773 2.247 29.054-1.602 40.346-9.689a.767.767 0 0 1 .894 1.247c-11.601 8.308-26.28 12.267-41.466 9.957-12.623-1.921-23.66-7.881-32.018-16.386a.766.766 0 1 1 1.09-1.073c8.134 8.277 18.872 14.075 31.154 15.944",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "small_svg__a",
    width: 169.231,
    height: 184.923,
    x: -5.475,
    y: -14.188,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5184_40357"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_5184_40357",
    result: "effect2_dropShadow_5184_40357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_5184_40357",
    result: "shape"
  })))));
};
export default SvgSmall;